import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useFormikContext, withFormik} from "formik";
import {isEqual} from "lodash";

import {fetchAllCountries, selectAllCountries} from "../../../slices/CatalogsSlice";
import FunctionButton from "../../../utilities/Buttons/FunctionButton";
import {swalCustom} from "../../../utilities/hooks/swalCustom";
import {toaster} from "../../../utilities/hooks/toaster";
import {TextInput} from "../../Inputs";
import PhoneInput from "../../Inputs/PhoneInput";
import {Select} from "../../Inputs/SelectField";
import {fetchAllDeliveryTerms, getCurrentProject, selectDeliveryTerms, updateProject} from "../ProjectSlice";

const RecipientDetails = ({setModalActive, setOnCloseProps}) => {
  const dispatch = useDispatch();
  const {values, setValues} = useFormikContext();

  const countries = useSelector(selectAllCountries);
  const deliveryTerms = useSelector(selectDeliveryTerms);
  const currentProject = useSelector(getCurrentProject);
  const projectNumber = currentProject?.projectNumber;
  const {
    payer,
    payerAddress,
    recipient,
    recipientAddress,
    customsClearenceOn,
    deliveryTermId,
    countryId,
    postalCode,
    phone,
    email,
    edrpouCode,
    account,
  } = currentProject?.recipient ?? {};

  const startValues = {
    projectNumber,
    payer,
    payerAddress,
    recipient,
    recipientAddress,
    customsClearenceOn,
    deliveryTermId,
    productCountryId: countryId,
    postalCode,
    phone,
    email,
    edrpouCode,
    account,
  };

  const areValuesChanged = !isEqual({...values, projectNumber: ""}, {...startValues, projectNumber: ""});

  useEffect(() => {
    setOnCloseProps({areValuesChanged});
  }, [areValuesChanged]);

  useEffect(() => {
    setValues({...startValues, projectNumber});
  }, [projectNumber]);

  useEffect(() => {
    if (!countries?.length) {
      dispatch(fetchAllCountries());
    }
  }, [countries?.length]);

  useEffect(() => {
    dispatch(fetchAllDeliveryTerms());
  }, []);

  const deliveryConditionOptions =
    deliveryTerms?.map(({deliveryTermId, code}) => ({title: code, value: deliveryTermId})) ?? [];

  const productCountryOptions =
    countries?.map(({countryId, shortName}) => ({title: shortName, value: countryId})) ?? [];

  function onSaveBtnClick() {
    const projectId = currentProject?.projectId;
    if (!projectId) return;

    const {
      payer,
      payerAddress,
      recipient,
      recipientAddress,
      customsClearenceOn,
      deliveryTermId,
      productCountryId,
      postalCode,
      phone,
      email,
      edrpouCode,
      account,
    } = values;

    dispatch(
      updateProject({
        projectId,
        data: {
          recipient: {
            payer,
            payerAddress,
            recipient,
            recipientAddress,
            customsClearenceOn,
            deliveryTermId,
            countryId: productCountryId,
            postalCode,
            phone,
            email,
            edrpouCode,
            account,
          },
        },
      }),
    ).then(resp => {
      if (resp.meta.requestStatus === "fulfilled") {
        toaster.success("Project updated");
        setModalActive(false);
      }
    });
  }

  function onCancelBtnClick() {
    swalCustom.confirm({
      confirmFunc: () => {
        setValues(startValues);
      },
    });
  }

  return (
    <div className="fcCol jcsb w100">
      <div className="fcCol w100 gap aistr mt2x" style={{paddingLeft: "50px", paddingRight: "50px"}}>
        <TextInput label="Project №" name="projectNumber" autolabel readOnly />
        <TextInput label="Payer name" name="payer" autolabel />
        <TextInput label="Payer Address" name="payerAddress" autolabel />
        <TextInput label="Recipient Name" name="recipient" autolabel />
        <TextInput label="Recipient Address" name="recipientAddress" autolabel />
        <TextInput label="Postal code" name="postalCode" generalClassName="w100" />
        <PhoneInput label="tel" name="phone" type="text" width="100%" />
        <TextInput label="e-mail" name="email" generalClassName="w100" />
        {/* <TextInput label={t("Payer`s EDRPOUO")} name="edrpouCode" generalClassName="w100" readOnly />
        <TextInput label={t("Payer`s account")} name="account" generalClassName="w100" readOnly /> */}
        <TextInput label="Customs clearance" name="customsClearenceOn" autolabel />
        <Select
          name="deliveryTermId"
          label="Delivery condition:"
          options={deliveryConditionOptions}
          width="5em"
          optionsAbove
        />
        <Select
          name="productCountryId"
          label="Product country"
          options={productCountryOptions}
          width="25em"
          optionsAbove
        />
      </div>
      <div className="row w100 jcc gap2x mt">
        <FunctionButton name="Save" autoWidth onClick={onSaveBtnClick} disabled={!areValuesChanged} />
        <FunctionButton name="Cancel2" autoWidth onClick={onCancelBtnClick} disabled={!areValuesChanged} />
      </div>
    </div>
  );
};

export default withFormik({
  enableReinitialize: true,
})(RecipientDetails);
